import { stats } from '@/mocks/stats';

export default function StatsSection() {
  return (
    <section className="py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-widest uppercase text-accent-500 mb-3 block">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Trusted by Thousands of{' '}
            <span className="italic text-primary-500">Superbuy Sheet</span> Users
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            Our spreadsheet hub is built on data, verified by real shoppers, and updated weekly to ensure you get the most reliable product information.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat, idx) => (
            <div
              key={stat.label}
              className={`rounded-2xl p-8 transition-all duration-300 hover:scale-[1.03] ${
                idx === 0
                  ? 'bg-primary-500 text-background-50'
                  : idx === 1
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-100 text-foreground-900'
              }`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-heading text-4xl md:text-5xl font-bold">
                  {stat.value}
                </span>
                <span
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    idx < 2
                      ? 'bg-background-50/20'
                      : 'bg-primary-50'
                  }`}
                >
                  <i
                    className={`ri-arrow-right-up-line ${
                      idx < 2 ? 'text-background-50' : 'text-primary-500'
                    } text-lg`}
                  ></i>
                </span>
              </div>
              <h3
                className={`text-lg font-semibold mb-1 ${
                  idx < 2 ? 'text-background-50' : 'text-foreground-900'
                }`}
              >
                {stat.label}
              </h3>
              <p
                className={`text-xs ${
                  idx < 2 ? 'text-background-50/70' : 'text-foreground-500'
                }`}
              >
                {stat.suffix}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}